import React from 'react';

import { T } from 'react-translator-component';

import { ChargePoint } from '../../../types/responses/ChargePoints';
import { getConnectorStatus } from '../../../utils/normalizers/connectorStatus';
import { ChargerPlugIcon } from '../../atoms/icons/ChargerPlugIcon';
import { ThunderIcon } from '../../atoms/icons/ThunderIcon';
import ConnectorColored from '../../molecules/ConnectorColored/ConnectorColored';

const MPT = ['Sem nome', T('Undefined'), '..'];

const innerDataFormater = (station: ChargePoint) => {
  return {
    chargeBoxId: station.chargeBoxId,
    about: {
      private: station.typeOf === 'PRIVATE',
      group: station.chargeBoxGroupName || MPT[1],
      brand: station.chargePointVendor,
      model: station.chargePointModel,
      chargerPk: station.chargeBoxPk,
      uuid: station.uuid,
      fwVersion: station.fwVersion,
      externalId: station.externalId || MPT[1],
    },
  };
};

const listFormater = (chargePointsList: ChargePoint[]) => {
  if (!chargePointsList) return { cardsList: [], innerData: [] };

  return chargePointsList.reduce(
    (list, station) => {
      return {
        cardsList: [
          ...list.cardsList,
          [
            {
              value: station.description || MPT[1],
              subValue: station.chargeBoxId,
              icon: <></>,
              size: '25%',
            },
            {
              value: station.tenantName || MPT[1],
              subValue: '',
              icon: <></>,
              size: '14%',
            },
            {
              value: station.address.state || MPT[2],
              subValue: '',
              icon: <></>,
              size: '7%',
            },
            {
              value: station.address.city || MPT[2],
              subValue: '',
              icon: <></>,
              size: '14%',
            },
            {
              value: station.usage,
              subValue: '',
              icon: <ChargerPlugIcon size={20} />,
              size: '10%',
            },
            {
              value: station.monthConsumption
                ? parseFloat(String(station.monthConsumption / 1000)).toFixed(2)
                : 0,
              subValue: '',
              icon: <ThunderIcon size={20} />,
              size: '12%',
            },
            {
              value: station.lastHeartbeatTimestamp,
              subValue: '',
              size: '15%',
              icon: <></>,
            },
            {
              value: '',
              subValue: '',
              size: '15%',
              icon: (
                <>
                  {station.connectors.map((connector, index) => (
                    <ConnectorColored
                      key={index}
                      connector={connector.connectorType}
                      socPercentage={
                        connector.lastStatus
                          ? connector.lastStatus.socPercentage
                          : null
                      }
                      connectorPk={connector.connectorPk}
                      status={getConnectorStatus(
                        connector.lastStatus.status,
                        connector.lastStatus.availabilityReason,
                      )}
                    />
                  ))}
                </>
              ),
            },
          ],
        ],
        innerData: [...list.innerData, innerDataFormater(station)],
      };
    },
    { cardsList: [] as any[], innerData: [] as any[] },
  );
};

export const combiningObjects = (list: ChargePoint[], header) => {
  return {
    header,
    ...listFormater(list),
  };
};

export const getConnectorsTypes = (list: ChargePoint[]) => {
  let connectors: any = [];

  list.forEach((station) => {
    station.connectors.length &&
      station.connectors.forEach((connector) => {
        const newConnector = {
          icon: <ConnectorColored connector={connector.connectorType} />,
          value: connector.connectorType,
        };
        connectors = [...connectors, newConnector];
      });
  });
};
